import SquareButton from "@/modules/common/components/ui/square-button";
import { MoreHoriz } from "@mui/icons-material";
import { Box, Menu, MenuItem } from "@mui/material";
import { Children, isValidElement, useState } from "react";

export default function MoreActionsMenu({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SquareButton
        title="More Actions"
        variant="outlined"
        color="secondary"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreHoriz />
      </SquareButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
          },
        }}
      >
        {/**
         * force menu close when child is clicked because custom components children
         * even with menu item doesnt close the menu
         */}
        {Children.map(children, (child) => {
          if (!isValidElement(child)) {
            return <MenuItem onClick={handleClose}>{child}</MenuItem>;
          }

          return (
            <Box
              onClick={(event: React.MouseEvent<HTMLElement>) => {
                child.props.onClick?.(event);
                // handleClose(); //TODO: To be re-visited - closes modals inside the menu items
              }}
            >
              {child}
            </Box>
          );
        })}
      </Menu>
    </>
  );
}
